import { useEffect } from 'react';

const GTranslate = () => {
  useEffect(() => {
    // GTranslate settings
    window.gtranslateSettings = {
      default_language: 'en',
      native_language_names: true,
      languages: ['en', 'ur'],
      wrapper_selector: '.gtranslate_wrapper',
      flag_size: 24,
    };

    // Load GTranslate script
    const script = document.createElement('script');
    script.src = 'https://cdn.gtranslate.net/widgets/latest/fn.js';
    script.defer = true;
    document.body.appendChild(script);

    // Create dynamic style element
    const style = document.createElement('style');
    document.head.appendChild(style);

    // Function to update widget position based on quote button presence
    const updateStyles = () => {
      const hasQuoteBtn = document.querySelector('.quote-floating-btn');
      style.innerHTML = `
        .gtranslate_wrapper {
          background: rgb(214, 239, 242) !important;
          padding: 2px !important;
          border-radius: 5px !important;
        }
        .gtranslate_wrapper span {
          color: #318d94 !important;
          font-weight: bold !important;
        }
      `;
    };

    // Run once after delay
    const timeout = setTimeout(updateStyles, 300);

    // Watch for DOM changes in case `.quote-floating-btn` appears later
    const observer = new MutationObserver(updateStyles);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Cleanup
    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
      if (style.parentNode) style.parentNode.removeChild(style);
      clearTimeout(timeout);
      observer.disconnect();
    };
  }, []);

  return <div className="gtranslate_wrapper" />;
};

export default GTranslate;
